module.exports = __webpack_public_path__ + "img/diap-1.ea3805e2.png";